var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFearlesslyScale2 = function SvgFearlesslyScale2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 786,
    height: 507,
    fill: "none",
    viewBox: "0 0 786 507"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fearlessly-scale-2_clip0_3_25)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#fearlessly-scale-2_filter0_i_3_25)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fearlessly-scale-2_paint0_linear_3_25)",
    d: "M996.898 568.684L1006.01 -114.565L797.999 -73L632.029 92.5074L565.952 188.583L509.299 199.033L444.645 198.927L396.773 209.666L328.927 209.556L243.5 198.601L184.434 198.505L109.369 178.913L-20.7695 160.673L-154.236 169.117L-269.791 168.93L-382.23 227.871L-439.717 218.403L-569.768 248.478L-730.175 264.803L-857.936 237.193L-919.963 247.909L-919.835 318.889L-915.546 551.869L996.898 568.684Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "whiteLine",
    filter: "url(#fearlessly-scale-2_filter1_i_3_25)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fearlessly-scale-2_paint1_linear_3_25)",
    fillOpacity: 0.01,
    d: "M1875.57 583.137L1884.72 -100.111L1706.08 -35.4518L1517.36 107.073L1452.44 203.168L1396.79 213.634L1333.3 213.549L1286.28 224.302L1219.64 224.212L1135.74 213.282L1077.73 213.204L1004.02 193.635L831.821 -105.809L676.243 183.826L631.633 183.766L521.185 242.74L464.728 233.29L336.991 263.404L179.445 279.777L53.975 252.206L-6.94701 262.94L-6.84301 333.92L-2.70035 566.897L1875.57 583.137Z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#fearlessly-scale-2_paint2_linear_3_25)",
    strokeDasharray: "8.65 8.65",
    strokeWidth: 1.442,
    d: "M809.064 98.79-12.98 98.79"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#fearlessly-scale-2_paint3_linear_3_25)",
    strokeDasharray: "8.65 8.65",
    strokeWidth: 1.442,
    d: "M809.064 297.81-12.98 297.81"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fearlessly-scale-2_paint0_linear_3_25",
    x1: -832.875,
    x2: 866.956,
    y1: 430.375,
    y2: 279.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C0BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#B3A3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BBB5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A92D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fearlessly-scale-2_paint1_linear_3_25",
    x1: 83.404,
    x2: 1843.44,
    y1: 445.178,
    y2: 283.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C0BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#CBB9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#C4BBCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5BCCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fearlessly-scale-2_paint2_linear_3_25",
    x1: 794.6,
    x2: -0.365,
    y1: 102.068,
    y2: 78.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#BDC1DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fearlessly-scale-2_paint3_linear_3_25",
    x1: 794.6,
    x2: -0.365,
    y1: 301.088,
    y2: 277.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C6DB"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fearlessly-scale-2_filter0_i_3_25",
    width: 1925.97,
    height: 686.129,
    x: -919.963,
    y: -114.565,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.88
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.885
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.886275 0 0 0 0 0.894118 0 0 0 0 0.945098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_3_25"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fearlessly-scale-2_filter1_i_3_25",
    width: 1891.67,
    height: 690.946,
    x: -6.947,
    y: -105.809,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.933333 0 0 0 0 0.942222 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_3_25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fearlessly-scale-2_clip0_3_25"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H786V507H0z"
  })))));
};
export default SvgFearlesslyScale2;